import { render, staticRenderFns } from "./ImportResume.vue?vue&type=template&id=22ca3108&"
import script from "./ImportResume.vue?vue&type=script&lang=js&"
export * from "./ImportResume.vue?vue&type=script&lang=js&"
import style0 from "./ImportResume.vue?vue&type=style&index=0&id=22ca3108&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports